import React from 'react'
import { Flash } from 'AWS-UI-Components-React'
import { FlashMessages } from './FlashMessageConstants'

export default class FlashMessageView extends React.PureComponent {

    render() {
        const { flashMessage, flashDismissed } = this.props
        return <Flash 
            className="awsui-util-mb-s"
            dismissible
            onDismiss={() => flashDismissed()}
            content={FlashMessages[flashMessage]().content}
            header={FlashMessages[flashMessage]().header}
            type={FlashMessages[flashMessage]().type}/>
    }
}


// WEBPACK FOOTER //
// ./src/components/FlashMessage/FlashMessageView.jsx